/* @flow */
// typecheck: ignore file
import CurrentUser from 'auth/CurrentUser';

import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

/* Returns an onEnter function that will require that a user can be a group owner.
 *
 * static onEnter = RequireOwner
 * static onEnter = chainOnEnter([RequireUser, RequireOwner])
 *
 */
const RequireOwner = {
  statics: {
    onEnter(nextState: RouterState, replaceWith: (location: LocationDescriptor) => void) {
      const user = CurrentUser.isSignedIn() ? CurrentUser.getUser() : null;
      if (!(user && user.canOwnGroups())) {
        replaceWith('/error');
      }
    },
  },
};

export default RequireOwner;



// WEBPACK FOOTER //
// ./src/components/mixins/RequireOwner.js